import { styled, Switch } from '@mui/material';

export const StyledToggle = styled(Switch, {
  shouldForwardProp: (prop) => prop !== 'labelPlacement',
})<{
  labelPlacement: 'end' | 'start' | 'top' | 'bottom';
}>(({ theme, labelPlacement }) => ({
  width: 32,
  height: 16,
  padding: 0,
  marginLeft: labelPlacement === 'start' ? 15 : 0,
  marginRight: labelPlacement === 'end' ? 15 : 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    transitionDuration: '300ms',
    color: theme.palette.grey.A100,
    opacity: 1,
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: theme.palette.primary.main,
      opacity: 1,
      '& + .MuiSwitch-track': {
        backgroundColor: '#CFE8D3',
        opacity: 1,
      },
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: 1,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 15,
    height: 15,
  },
  '& .MuiSwitch-track': {
    borderRadius: 15,
    backgroundColor: '#EAEDF1',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));
